import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ページ遷移時にウィンドウのトップにスクロールするためのコンポーネント。
 * ただし、location.stateに `targetId` が含まれる場合（別ページからのアンカーリンク）は、
 * Home.jsのスクロール処理を妨げないように、このコンポーネントは動作しない。
 */
function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    // stateにtargetIdがない場合のみ、ページのトップにスクロールする
    if (!state?.targetId) {
      window.scrollTo(0, 0);
    }
    // `state`も依存配列に含めることで、stateの変更時にもeffectが再実行されることを保証する
  }, [pathname, state]);

  return null; // このコンポーネントはUIを描画しない
}

export default ScrollToTop;
